export default {
	navbar: {
		home: 'Home',
		doLogin: 'Sign In',
		document: 'Documentation',
		regist: 'Sign Up',
		login: {
			control: 'Control Center',
			logOut: 'Sign Out'
		},
		notice: {
			logOut: {
				title: 'Notice',
				message: 'Log Out Now？',
				confirm: 'Yes',
				cancel: 'No',
			}
		}
	},
	login: {
		title: 'Sign In',
		account: 'Email/Username',
		password: 'Password',
		remember: 'Remember Me',
		forgot: 'Forgot Password？',
		btn: 'Login',
		control: 'Control Center',
		switch: 'Switch the account',
		loginRule: {
			username: 'Please enter email or username',
			password: 'Please enter password'
		}
	},
	home: {
		introduce: 'What is JOSH Cloud?',
		introDoc: 'JOSH Cloud is an intelligent device management system for Internet of Things (IOT) built for developers. Users can manage devices and applications, upload applications to the platform by themselves.',
		regist: 'Join Platform',
		registDoc: 'Users can join and use the platform through JOSH Cloud account. After the first login, users are advised to improve their personal information in order to use the functions of the platform. (Note: Forget password operation needs account mailbox, please activate first!)',
		registContent: {
			step1: 'Sign Up Account',
			step2: 'Sign In Platform',
			step3: 'Active Mailbox',
			step4: 'Bind/Active Security Mailbox'
		},
		develop: 'Guidelines for Platform Use',
		devDoc: 'JOSH Developer Platform is an intelligent device management system for Internet of Things. The purpose of this document is to describe and explain the process and operation of the platform in an all-round way so that developers can get familiar with the platform functions more quickly.',
		sdk: 'SDK Use Tutorial',
		sdkDoc: 'This document guides developers to develop and debug development board applications quickly through several tutorials such as IDE instructions, installation and debugging of development board, and introduction of development board. It also provides a large number of API use examples for developers to refer to.',
		vm: 'JoshVM Open Document',
		vmDoc: 'Coming soon……' ,
		community: 'Josh Community',
		communityLink: 'The JOSH developer community is an open technology platform for developers. Including questions and answers, technology sharing, resource downloading and other modules, to share professional, high-quality, efficient technology as the main goal, to help technologists grow and develop rapidly.' 
	},
	navMenu: {
		overview: 'Overview',
		deviceManage: 'DeviceManage',
		device: 'Device',
		group: 'Group',
		task: 'Task',
		certificate: 'CertManage',
		appManage: 'AppManage',
		user: 'User',
		helpDoc: 'HelpDoc',
		server: 'Server',
		serverAudio: 'Audio',
	},
	server: {
		noData: 'to do',
		audio: {
			key: 'ApiKey',
			secret: 'ApiSecret',
			table: {
				orderIndex: 'to do',
				name: 'to do',
				limit: 'to do'
			}
		}
	},
	userinfo: {
		title: 'Userinfo',
		username: 'Username',
		nickname: 'Nickname',
		edit: 'Edit',
		add: 'Add',
		captchaTip: 'Graphic verification code case sensitive',
		backGet: 'Get mailbox activation code',
		editAvatar: 'Edit Avatar',
    loginMailbox: 'Login mailbox',
    emailActiveCode: 'Email activation code',
    securityEmailActiveCode: 'Safe Mailbox Activation Code',
   	next: 'Next',
    nickname: 'nickname',
    toActive: 'Active',
    secureMailbox: 'Secure mailbox',
    deviceNumber: 'Device number',
    groupNumber: 'Group number',
    resetPassword: 'Reset password',
    captcha: 'Captcha',
    activateMailbox: 'Activate Mailbox',
    activateSafeMailbox: 'Activate Safe Mailbox',
    authentication: {
    	authentication: 'Authentication',
    	tips: 'Modifying account information requires entering a security authentication code for authentication. The security authentication code has been sent to a secure mailbox',
    	tipsTwo: 'Please go and check it out',
    	regain: 'Regain',
    	confirm: 'Confirm'
    },
    editPassword: {
    	resetPassword: 'Reset password',
    	oldPassword: 'Old password',
    	newPassword: 'New password',
    	newPasswordTip: 'The password is composed of 6-20 digits and letters',
    	confirmPassword: 'Confirm password',
    	confirm: 'Confirm',
    	editRule: {
    		oldPassword: 'Please enter old password',
    		newPassword: 'Please enter new password',
    		newPasswordError: 'The password must consist of 6-20 digits and letters',
    		confirm: 'Please confirm the password again',
    		confirmError: 'The two password is different. Please reconfirm'
    	}
    },
    editNickname: {
    	title: 'Edit nickname',
    	add: 'Add nickname',
    	confirm: 'Confirm',
    	newNickname: 'New nickname',
    	editRule: {
    		newNickname: 'Please enter new nickname',
    	}
    },
    editSecurityEmail: {
    	editEmail: 'Edit security mailbox',
    	addEmail: 'Add a secure mailbox',
    	confirm: 'Confirm',
    	newEmail: 'New mailbox',
    	editRule: {
    		newSecurityEmail: 'Please enter new security mailbox',
    		newSecurityEmailError: 'The mailbox format is incorrect. Please fill it in again',
    	}
    },
    editLoginEmail: {
    	editEmail: 'Edit login mailbox',
    	confirm: 'Confirm',
    	newEmail: 'New mailbox',
    	captcha: 'captcha',
    	editRule: {
    		newLoginEmail: 'Please enter new login mailbox',
    		newLoginEmailError: 'The mailbox format is incorrect. Please fill it in again',
    		captcha: 'Please enter captcha',
    		emailActiveCode: 'Please enter the email activation code',
    		securityEmailActiveCode: 'Please enter the activation code Mail Security'
    	}
    },
    editAvatar: {
    	changePic: 'Change picture',
    	editAvatar: 'Edit avatar',
    	upload: 'upload',
    },
    deviceType: {
    	title: 'to do',
    	noData: 'to do',
    	orderIndex: 'to do',
    	name: 'to do',
    	authType: 'to do',
    	total: 'to do',
    	noLimit: 'to do'
    }
	},
	control: {
		overview:{
			title: 'Monitor / Overview',
			deviceNum: 'Device number',
			groupNum: 'Group number',
			appNum: 'App number',
			taskNum: 'Task number',
			activeNum: 'Activation number',
			onlineNum: 'Online number',
			isDoing: 'Running',
			goBuy: 'GO Buy'
		},
		device: {
			list: {
				title: 'Device List',
				deviceNumber: 'DeviceNumber',
				deviceName: 'DeviceName',
				deviceType: 'DeviceType',
				IMEI: 'IMEI',
				missionState: 'Task state',
				grouping: 'Groupings',
				appInfo: 'Application information',
				activeState: 'Activation state',
				connectState: 'Connection state',
				lastOnlineTime: 'Last online time',
				select: 'Please select',
				noData: 'No data',
				otherSet: 'OtherSet',
				connectionSettings: 'Connection Check Settings',
				setCheck: 'Set to check',
				setNoCheck: 'Set to no check',
				checkStatus: 'Connection Check Status',
				check: 'CHeck',
				noCheck: 'NoCheck',
				choseDevice: 'Please select the device to set up',
				confirmSet: "Make sure that it's set to",
				confirm: 'Confirm',
				tips: 'Tips',
				operateSuccess: 'Operate Success',
				cancel: "Cancelled",
				operate: 'Operate',
				add: 'Add',
				empty: 'Clear',
				query: 'Query',
				look: 'Look',
				delete: 'Delete',
				applyDelete: 'Apply delete',
				remove: 'Remove',
			},
			create: {
				title: 'Add Device',
				deviceName: 'Device name',
				IMEI: 'IMEI',
				groups: 'Groupings',
				type: 'Type',
				select: 'Please select',
				confirm: 'Confirm',
				rule: {
					name: 'Please enter Device name',
					imei: 'Please enter IMEI'
				}
			},
			detail: {
				title: 'Device Detail',
				deviceNumber: 'DeviceNumber',
				deviceName: 'DeviceName',
				createTime: 'Create time',
				getCode: 'Get activation code',
				getPaper: 'Generate certificates',
				code: 'Activation code',
				paperNotic: 'The generated certificate will overwrite the original certificate, and the platform will not be saved. Please manage it properly.',
				expireTime: 'Expiration date',
				copy: 'Copy',
				copySuccess: 'Copy success',
				lastConnectTime: 'Last connection time',
				group: 'Groupings',
				deviceType: 'Device type',
				activeState: 'Activation state',
				connectState: 'Connection state',
				connectCheck: 'Connection check state',
				appInfo: 'Application information',
				taskRecord: 'Task record',
				logList: 'Log list',
				app: {
					appList: 'App list',
					addApp: 'Add app',
					name: 'Name',
					version: 'Version',
					mainClass: 'MainClass',
					remark: 'Remark',
					state: 'State',
					createTime: 'Create Time',
					operate: 'Operate'
				},
				task: {
					taskRecord: 'Task Record',
					addTask: 'Add Task',
					taskNumber: 'Task number',
					taskType: 'Task type',
					createTime: 'Create time',
					select: 'Please select',
					startTime: 'StartTime',
					to: 'To',
					endTime: 'EndTime',
					remake: 'Remark',
					otherSet: 'Other settings ',
					appInfo: 'Application information',
					launchTime: 'LaunchTime',
					endTime: 'Finish time',
					deviceNum: 'Device number',
					finishNum: 'Finish number',
					taskState: 'Task state',
					noData: 'No data',
					operate: 'Operate',
					add: 'Add',
					empty: 'Clear',
					query: 'Query',
					look: 'Look',
					delete: 'Delete',
					serialNumber: 'Serial Number',
				},
				log: {
					logList: 'Log list',
					reportType: 'Report type',
					reportContent: 'Report content',
					reportTime: 'Reporting time',
					taskNumber: 'TaskNumber',
					taskItemNumber: 'TaskItemNumber',
					createTime: 'createTime',
					query: 'Query',
					empty: 'Clear',
					serialNumber: 'Serial Number',
				}
			}
		},
		group: {
			list: {
				title: 'Group List',
				groupNumber: 'GroupNumber',
				groupName: 'GroupName',
				createTime: 'Create time',
				addTime: 'AddTime',
				deviceNum: 'Device number',
				startTime: 'StartTime',
				to: 'To',
				endTime: 'EndTime',
				noData: 'No data',
				operate: 'Operate',
				remake: 'Remark',
				add: 'Add',
				empty: 'Clear',
				query: 'Query',
				look: 'Look',
				delete: 'Delete',
			},
			create: {
				editTitle: 'Edit Group',
				title: 'Add Group',
				groupName: 'GroupName',
				remake: 'Remark',
				confirm: 'Confirm',
				rule: {
					name: 'Please enter name',
					imei: 'Please enter imei',
					deviceType: 'Please select type'
				}
			},
			detail: {
				title: 'Group Detail',
				groupNumber: 'GroupNumber',
				groupName: 'GroupName',
				createTime: 'Create time',
				deviceNum: 'Device Qty',
				activeNum: 'Activation number',
				onlineNum: 'Online number',
				remake: 'Remark',
				deviceList: 'Device list',
				taskRecord: 'Task record'
			}
		},
		task: {
			list: {
				title: 'Task List',
				taskNumber: 'Task number',
				taskType: 'Task type',
				createTime: 'Create time',
				select: 'Please select',
				startTime: 'StartTime',
				to: 'To',
				endTime: 'EndTime',
				remake: 'Remark',
				otherSet: 'Other settings ',
				appInfo: 'Application information',
				launchTime: 'LaunchTime',
				endTime: 'FinishTime',
				deviceNum: 'Device number',
				finishNum: 'Finish number',
				noData: 'No data',
				operate: 'Operate',
				add: 'Add',
				empty: 'Clear',
				query: 'Query',
				look: 'Look',
				delete: 'Delete',
			},
			create: {
				title: 'Add task',
				taskNumber: 'TaskNumber',
				taskType: 'TaskType',
				configure: 'Configure',
				remark: 'Task Remark',
				selectDevice: 'Select Device',
				selectGroup: 'Select Group',
				abstract: 'Abstract',
				appSelect: 'App Select',
				number: 'Number',
				name: 'Name',
				type: 'Type',
				rule: {
					taskNumber: 'Please enter the task number',
					type: 'Please select task type'
				}
			},
			detail: {
				title: 'Task Detail',
				taskNumber: 'TaskNumber',
				taskType: 'Task type',
				otherSet: 'Other settings',
				deviceNum: 'Device Qty',
				appName: 'AppName',
				finishNum: 'Finish number',
				version: 'version',
				createTime: 'Create time',
				remake: 'Remark',
				deviceList: 'Device list',
				finalReport: 'FinalReport',
				taskState: 'TaskState',
				uploadTime: 'UploadTime'
			}

		},
		cert: {
			list: {
				title: 'Cert List',
				certNumber: 'CertNumber',
				certName: 'CertName',
				relation: 'Number of associated devices',
				select: 'Please select',
				state: 'State',
				enable: 'Enable',
				disable: 'Disable',
				createTime: 'Create time',
				operate: 'Operate',
				noData: 'No data',
				add: 'Add',
				query: 'Query',
				empty: 'Clear',
				look: 'Look',
				delete: 'Delete',

			},
			create: {
				title: 'Add Cert',
				certName: 'CertName',
				cert: 'Cert',
				publicKey: 'Public key',
				privateKey: 'Private key',
				download: 'Download',
				confirm: 'Confirm'
			},
			detail: {
				title: 'Cert Detail',
				certNumber: 'CertNumber',
				certName: 'CertName',
				state: 'State',
				download: 'Download',
				deviceNum: 'Device Qty',
				publisher: 'Publisher',
				theme: 'Theme',
				createDate: 'Create date',
				effectiveDate: 'Effective date',
				expirationDate: 'Expiration date'
			}
		},
		app: {
			list: {
				title: 'App List',
				appName: 'AppName',
				version: 'Version',
				mainClass: 'MainClass',
				remake: 'Remark',
				uploadTime: 'Upload time',
				deleteState: 'Deleted state',
				operate: 'Operate',
				noData: 'No data',
				add: 'Add',
				query: 'Query',
				empty: 'Clear',
				look: 'Look',
				delete: 'Delete',

			},
			create: {
				editTitle: 'Edit App',
				title: 'Add App',
				appName: 'AppName',
				version: 'Version',
				mainClass: 'MainClass',
				file: 'Source file',
				selectFile: 'Select files',
				remake: 'Remark',
				confirm: 'Confirm',
				cDelete: 'Determine to remove ',
				rule:{
					name: 'Please enter app name',
					version: 'Please enter version',
					mainClass: 'Please enter mainclassname',
					file: 'Please upload files',
					remark: 'Please enter remark'
				}
			},
			detail: {
				title: 'App Detail',
				appName: 'AppName',
				version: 'Version',
				uploadTime: 'Upload time',
				mainClass: 'MainClass',
				remake: 'remark',
				file: 'Source files',
				download: 'Download',
				delete: 'Delete'
			}
		}
	},
	regist: {
		login: 'Sign In',
		title: 'Create a new Developer account',
		username: 'Enter your username',
		usernameTip: '5-25 bits，Case insensitive，Once the username is set up, it cannot be modified',
		email: 'Enter your email',
		emailTip: 'Please enter the unused email,The email can be modified in the Control',
		password: 'Enter your password',
		passwordTip: 'Password is composed of 6-20 digits and letters',
		confirm: 'Confirm your password',
		agreement1: '《Developer Agreement》',
		agreement2: '《Privacy Policy》',
		btn: 'Sign Up',
		registRule: {
			usernameEmpty: 'Please enter your username',
			usernameError: 'The length of username needs 5-25 characters',
			emailEmpty: 'Please enter your email',
			emailError: 'Email format is abnormal, please check it',
			passwordEmpty: 'Please enter your password',
			passwordError: 'Password is composed of 6-20 digits and letters',
			confirmEmpty: 'Please confirm your password',
			confirmError: 'The two password is different. Please reconfirm'
		}
	},
	forgot: {
		step1: 'Verification Account',
		step1Tip: 'Fill in account username or email to get validation code',
		step2: 'Get Verification Code',
		step2Tip: 'Login mailbox for verification code',
		step3: 'Reset Password',
		step3Tip: 'Reset Account Password',
		back: 'back',
		success: 'Reset Success',
		btn: 'Sign In'
	},
	forgotStep1: {
		username: 'Email/Username',
		captcha: 'Captcha',
		captchaTip: 'Not clear, click again',
		btn: 'Get Verification Code',
		rule: {
			account: 'Please enter your username or email',
			captcha: 'Please enter captcha'
		}
	},
	forgotStep2: {
		code: 'Verification Code',
		codeTip: 'The verification code has been sent to the mailbox.Please check it',
		btn: 'Next',
		rule: {
			code: 'Please enter verification code'
		}
	},
	forgotStep3: {
		password: 'New Password',
		passwordTip: 'Password is composed of 6-20 digits and letters',
		confirm: 'Confirm your password',
		btn: 'Complete',
		rule: {
			passwordEmpty: 'Please enter your new password',
			passwordError: 'Password is composed of 6-20 digits and letters',
			confirmEmpty: 'Please confirm your new password',
			confirmError: 'The two password is different. Please reconfirm'
		}
	},
	confirm: {
		confirm: 'Confirm',
		cancel: 'Cancel',
   	deleteImmediately: 'Delete immediately',
   	applyDeleteImmediately: 'Apply delete immediately',
   	removeImmediately: 'Remove immediately',
    noDeletion: 'No deletion',
    notRemoved: 'Not removed',
    notApply: 'Not apply',
    tips: 'Tips',
    process: 'Processing',
    deleteApp: 'Determine to delete the application？',
    deleteGroup: 'Determine to delete the group？',
    deleteCert: 'Determine to delete the certificate？',
    deleteDevice: 'Determine to delete the device？',
    applyDeleteDevice: 'Determine to apply delete the device？',
    removeDevice: 'Determine to remove the device？',
    deleteTask: 'Determine to delete the task？',
    addSuccess: 'Add success',
    editSuccess: 'Edit success',
    operateSuccess: 'Successful operation，',
    deviceDelete: 'device deleted',
    deviceApplyDelete: 'device apply deleted',
    deviceRemove: 'device removed',
    groupDelete: 'group deleted',
    taskDelete: 'task deleted',
    appDelete: 'app deleted',
    certDelete: 'cert deleted',
    activeSuccess: 'Successful activation',
    getPaper: 'The generated certificate will overwrite the original certificate. The original certificate will be invalid. Do you want to generate the certificate?',
	},
	tips: {
		bindPhone: {
			addDevice: 'to do',
			useAudio: 'to do',
			page: 'to do',
			action: 'to do'
		}
	},
	fixedBar: {
		feedback: 'Feedback',
		backTop: 'Back to top',
	}
}


// WEBPACK FOOTER //
// ./src/lang/en.js